import React, { Component } from 'react';
import { inject, observer } from "mobx-react";

const BrandImages = inject("stores") (
    observer (
        class BrandImages extends Component {
            constructor(props) {
                super(props);
                this.props = props;
                this.urlAPI = process.env.REACT_APP_URL_API;

                this.state = {

                }

                this.storeUi = this.props.stores.storeUi;
            }

            componentDidMount = () => {
            }

            checkSize = (idx) => {
                let sizeClass = '';
                sizeClass = this.props.large && this.props.large.includes(idx) ? "--large" : "--regular";
                
                return sizeClass;
            }

            render() {
                return (
                    this.props.data.map((data, idx) => (
                        data.type == 'image' &&
                            <div className={"block--brand__column-section " + this.checkSize(idx)}>
                                {data.type == 'image' &&
                                    <img src={this.urlAPI + "/adam/public/images/lookbook/" + this.props.name + "/" + data.value} />
                                }      
                            </div>
                    ))
                );
            }
        }
    )
)

export default BrandImages;
